import Typography from '@alltrails/core/components/Typography';
import getHelpCenterUrl from '@alltrails/core/utils/getHelpCenterUrl';
import Link from '@alltrails/denali/components/Link';
import Modal from '@alltrails/modal/components/Modal/Modal';
import styles from './AskBetaInfoModal.module.scss';

// Legal's wording, split around the "Help Center" links
// hwandrew TODO: XPLR-204 translations
const title = 'About Ask AllTrails';
const betaToolCopy =
  'Ask AllTrails is a Beta tool under active development and testing. Responses are generated by third-party artificial intelligence synthesizing trail data, maps, and community reviews as preliminary suggestions only; this tool is strictly an informational aid and not a substitute for offline topographic maps, GPS devices, official park alerts, or emergency services. Because trail, weather, and access conditions change rapidly, you assume all risk and remain solely responsible for evaluating your route, gear, and personal safety.';
const dataUseCopy =
  'Messages are processed through enterprise cloud AI infrastructure to generate immediate answers, and are not sold, shared for third-party advertising, or used to train public foundation models.';
const sensitiveDataCopy =
  'Please do not submit payment information, passwords, or sensitive personal data in chat prompts. For account, billing, or subscription assistance, please visit our';
const ratingsCopyBeforeLink = 'You can help improve this Beta by rating responses with the thumbs-up and thumbs-down icons, or visit our';
const ratingsCopyAfterLink = 'at any time to connect with human support.';
const helpCenterLabel = 'Help Center';

type AskBetaInfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const helpCenterLink = (
  <Link href={getHelpCenterUrl('en-US')} target="_blank">
    {helpCenterLabel}
  </Link>
);

/**
 * Legal's full disclosure for Ask AllTrails, opened from the sidebar notice's "Learn more". The Help Center link
 * goes to the en-US Help Center, since Ask only releases to en-US.
 */
const AskBetaInfoModal = ({ isOpen, onClose }: AskBetaInfoModalProps) => (
  <Modal isOpen={isOpen} onCloseRequest={onClose} title={title}>
    <div className={styles.paragraphs}>
      <Typography mb="0" mt="0" component="p" variant="text200">
        {betaToolCopy}
      </Typography>
      <Typography mb="0" mt="0" component="p" variant="text200">
        {dataUseCopy}
      </Typography>
      <Typography mb="0" mt="0" component="p" variant="text200">
        {sensitiveDataCopy} {helpCenterLink}.
      </Typography>
      <Typography mb="0" mt="0" component="p" variant="text200">
        {ratingsCopyBeforeLink} {helpCenterLink} {ratingsCopyAfterLink}
      </Typography>
    </div>
  </Modal>
);

export default AskBetaInfoModal;
